import { hooks, libs } from '@fasstech/spid-front';
import * as R from 'ramda';
import React from 'react';
import useKeyPressEnter from '../../../../hooks/useKeyPressEnter';

const useEmployeesStep = ({
  bundledCollege,
  amendment,
  staff,
  setStaff,
  goNextStep,
  ccn,
  offerType,
  userRole,
  setTariffStructure,
  tariffStructure,
  resetHealthContractDescription,
  isProtectionAmendment,
  isHealthAmendment,
  isAmendment
}) => {
  const {
    displayInfo,
    formerColleges,
    isSelected,
    collegeIs,
    colleges,
    isValid,
    onChange,
    collegesPopup,
    setSelectedCategories,
    selectedCategories,
    getCount,
    selectedCategoriesToSave,
    totalNumberOfEmployeesIsValid,
    numberOfEmployeesV2ErrorMessage,
    maxNumberOfTotalEmployees,
    disabledColleges
  } = hooks.useColleges({
    ccn: userRole === 'reseau_commercial' ? ccn : R.dissocPath([offerType, 'maxNumberOfTotalEmployees'], ccn),
    bundledCollege,
    staff,
    amendment,
    isProtectionAmendment,
    isHealthAmendment,
    isAmendment,
    offerType
  });

  const [takeChargeOfBeneficiaries, setTakeChargeOfBeneficiaries] = React.useState(R.includes(tariffStructure, ['FAMILLE', 'UNIFORME']));
  const [tariffStructureIsUniform, setTariffStructureIsUniform] = React.useState(tariffStructure === 'UNIFORME');

  const onNext = () => {
    setStaff(selectedCategoriesToSave, undefined, offerType);

    const newTariffStructure = R.cond([
      [R.propEq('takeChargeOfBeneficiaries', false), R.always('ISOLE')],
      [R.propEq('tariffStructureIsUniform', true), R.always('UNIFORME')],
      [R.propEq('takeChargeOfBeneficiaries', true), R.always('FAMILLE')],
      [R.T, R.always(null)]
    ])({ takeChargeOfBeneficiaries, tariffStructureIsUniform });

    setTariffStructure(newTariffStructure);

    if (offerType === 'SANTE') { // On nettoie contractDescription si la structure tarifaire a changé
      resetHealthContractDescription();
    }

    goNextStep();
  };

  // "Dupliqué" dans SPID Client
  const objectiveCategoriesAreValid = R.compose(
    R.reduce((acc, [college, collegeData]) => {
      const collegeHasObjectiveCategories = !R.pathSatisfies(R.isNil, [offerType, 'objectiveCategories', college])(ccn);

      if (collegeHasObjectiveCategories && R.pathSatisfies(R.isNil, ['objectiveCategory', 'option'], collegeData)) {
        return false;
      }

      return acc;
    }, true),
    R.toPairs,
    R.filter(R.propEq('isSelected', true))
  )(selectedCategories);

  const _isValid = isValid && objectiveCategoriesAreValid;

  useKeyPressEnter(onNext, _isValid);

  const tariffStructures = R.propOr([], 'tariffStructures', ccn);

  return {
    formerColleges,
    isSelected,
    collegeIs,
    colleges,
    buttonDisabled: !_isValid,
    onNext,
    onChange,
    collegesPopup,
    setSelectedCategories,
    selectedCategories,
    getCount,
    displayInfo,
    totalNumberOfEmployeesErrorMessage: totalNumberOfEmployeesIsValid ? null : `Effectif maximum autorisé est de ${maxNumberOfTotalEmployees} salariés`,
    numberOfEmployeesV2ErrorMessage,
    setTakeChargeOfBeneficiaries,
    takeChargeOfBeneficiaries,
    tariffStructures,
    tariffStructureIsUniform,
    setTariffStructureIsUniform,
    disabledColleges
  };
};

export default useEmployeesStep;
